import React from 'react'
import moment from 'moment'
import classnames from 'classnames'
import type { DateHeaderProps } from 'react-big-calendar'
import { makeStyles } from '@paintscout/ui'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    color: theme.paintscout.palette.brand.Neutral.P60,
    padding: theme.spacing(1.125, 1.5, 1.25, 1.5),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 500,
    lineHeight: 1,
    zIndex: 1000,
    position: 'relative'
  },
  label: {
    margin: 0,
    cursor: 'pointer',
    pointerEvents: 'auto',
    color: theme.paintscout.palette.brand.Neutral.P60,
    '&:hover': {
      color: theme.palette.primary.main
    }
  },
  todayLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 22,
    height: 22,
    padding: theme.spacing(0, 0.5),
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.paintscout.palette.primary,
    color: `${theme.palette.common.white} !important`,
    fontWeight: 600,
    lineHeight: 1
  }
}))

export default function MonthDateHeader(props: DateHeaderProps) {
  const classes = useStyles()
  const { onDrillDown, label, date } = props
  const isToday = moment(date).isSame(moment(), 'day')
  return (
    <div className={classes.root}>
      <p className={classnames(classes.label, { [classes.todayLabel]: isToday })} onClick={onDrillDown}>
        {label}
      </p>
    </div>
  )
}
